import React, {useState, useContext} from "react";
import {
  Button, Card,
  CardBody,
  CardHeader, CardFooter,
  CardTitle,
  Form,
  FormGroup, Input, CustomInput,
  Label,
  Nav, NavItem, NavLink,
  TabContent, TabPane,
  Row, Col, InputGroup, InputGroupAddon
} from "reactstrap";
import { observer } from "mobx-react-lite";
import { StyledDropzone } from "../../elements/fileUpload/StyledDropzone";
import TagSelect from "../../elements/tags/TagSelect";
import {useIntl, FormattedMessage } from "react-intl";
import GroupSelect from "../../elements/groups/GroupSelect";
import Select from "react-select";
import PublishDomainSelectView from "../../elements/publishDomain/PublishDomainSelectView";
import {StateContext} from "../../../App";
import QrConfigSelect from "../../elements/qrconfig/QrConfigSelect";
import CodeFilterSelect from "../../elements/filters/CodeFilterSelect";
import BatchSelect from "../../elements/batch/BatchSelect";
import QrDownloadView from "../../qr/qrpreview/qrDownload/QrDownloadView";
import {batchEditTypes, batchTypesConstatns, batchEditTag, codeStatus, formConstants, selectedBatchCreateCodetype, ADVANCED_SETTINGS_MANAGE_SET, batchEditAdvancedConfigs} from "../../../utils/constants";
import UtmModal from "../../utms/modal/UtmModal";
import GenericModal from "../../elements/modal/GenericModal";
import ParameterSetModal from "../../configs/parametersets/modal/ParameterSetModal";
import RuleSetModalView from "../../configs/rulesets/modal/RuleSetModalView";
import {requiredRolesCheck} from "../../../utils/requiredRolesCheck";
import DesignerModal from "../../qr/modal/DesignerModal";
import StatusView from "../../configs/status/StatusView";
import ExtendedDataSettingModal from "../../extendedData/modal/ExtendedDataSettingModal";
/**
 Form Component to Upload Batch
 */
const BatchForm = observer(({ batchFromState }) => {
  const intl = useIntl();
  const stateContext = useContext(StateContext);
  //TODO: PATTERN VIOLATIONS - Multiple state-modifying operations called on every render:
  // 1. Line 40: batchFromState.setOnSelectChanges() - State-modifying method on every render
  // 2. Lines 41-47: batchFromState.codeFilterSelectState.set* methods (setEmails, setCodeTypes, etc.) - State mutations on every render
  // 3. Line 58: qrConfigSelectStore?.setHydrateModal() - State-modifying method on every render (below)
  // Correct solution: Move all state initialization/modification to route onEnter or MST actions
  // See correct pattern: src/routes/codes/index.js onEnter handlers for state initialization
  console.log("zhe init batchForm")
  batchFromState.setOnSelectChanges();
  batchFromState?.codeFilterSelectState.setEmails(batchFromState?.codeModels?.filters?.users);
  batchFromState?.codeFilterSelectState.setCodeTypes(batchFromState?.codeModels?.filters?.types);
  batchFromState?.codeFilterSelectState.setStatusTypes(batchFromState?.codeModels?.filters?.status);
  batchFromState?.codeFilterSelectState.setDomains(batchFromState?.codeModels?.filters?.domains);
  batchFromState?.codeFilterSelectState.setBehaviorTypes(batchFromState?.codeModels?.filters?.behaviors);
  batchFromState?.codeFilterSelectState.setAuditStatus([]);
  batchFromState?.codeFilterSelectState.setAuditEnabled(batchFromState?.codeModels?.isAuditActionEnabled);
  const { title, handleSubmit, uploadFiles, handleCancel, downloadType, batchType } = batchFromState;
  const availableSelectedTagOptions = batchFromState.availableNewSelectedTags.map(tag => ({
    value: tag.uuid,
    label: tag.name,
    // isDisabled: batchFromState.selectedTags.includes(tag.uuid) // we let user select everything
  }));
  const availableNewSelectedTagIds = batchFromState.availableNewSelectedTags;
  const updatedSelectedTagsOptions = availableSelectedTagOptions.filter(option => availableNewSelectedTagIds.includes(option.value));
  const qrConfigSelectStore = stateContext.rootUiStore.qrConfigSelectStore
  const qrPreviewStore = stateContext.rootUiStore.qrPreviewStore
  qrConfigSelectStore?.setHydrateModal(batchFromState.designerModalState.designerViewStore?.hydrateEditComponent)
  const userRoles = stateContext?.userRoles
  return (
    <>
    <Card>
      <CardHeader>
        <CardTitle tag="h5">{title}</CardTitle>
      </CardHeader>
      <CardBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Batch Name:</Label>
            <Input type="text"
                   name="batchName"
                   onChange={batchFromState.handleBatchNameChange}
                   value={batchFromState.batchName}
                   disabled={!batchFromState.isBatchEditable}
                   required/>
          </FormGroup>
          <FormGroup>
            <Label>
              Batch Type:
            </Label>
            {/* <Input
              type="select"
              id="batchType"
              name="batchType"
              onChange={handleBatchTypeChange}
            >
              <option>Create</option>
              <option>Download</option>
            </Input> */}
            <Select
              id="batchType"
              name="batchType"
              onChange={(data)=>batchFromState.setBatchType(data.value, qrPreviewStore)}
              value={{ value: batchFromState.batchType, label: batchFromState.batchType }}
              options={[
                { value: batchTypesConstatns.CREATE, label: batchTypesConstatns.CREATE },
                { value: batchTypesConstatns.DOWNLOAD, label: batchTypesConstatns.DOWNLOAD },
                { value: batchTypesConstatns.EDIT, label: batchTypesConstatns.EDIT },
              ]}
              isDisabled={!batchFromState.isBatchEditable}
              // defaultValue={{ value: batchTypesConstatns.CREATE, label: batchTypesConstatns.CREATE }}
            />
          </FormGroup>
          {!batchFromState?.isBatchEditable && (
            <FormGroup>
              <Label>
                Created Date:
              </Label>
              <Input type="text" name="createdDate" value={batchFromState.createdDate} disabled/>
            </FormGroup>
          )}
          <hr/>
          {(batchType === batchTypesConstatns.DOWNLOAD || batchType === batchTypesConstatns.EDIT)&& (
            <>
              {batchFromState?.isBatchEditable && (
              <Row>
                <Col sm={5}>

                  <Label className="text-sm-left"><FormattedMessage id="batchForm.defaultSwitch.defaultMessage"/></Label>

                </Col>
                <Col sm={3}>
                  <CustomInput
                    type="switch"
                    id="isDefaultBatchOperation"
                    name="isDefaultBatchOperation"
                    checked={batchFromState?.isDefaultBatchOperation}
                    onChange={() => batchFromState.toggleIsDefaultBatchOperation()}
                  />
                </Col>
              </Row>
              )}
            </>)
          }
          {!batchFromState?.isDefaultBatchOperation || batchType === batchTypesConstatns.CREATE ? (
              <>
                <FormGroup>
                  <Label className="text-sm-right"><FormattedMessage id="createQr.groups.defaultMessage"/>:</Label>
                  <GroupSelect groupSelectStore={batchFromState.groupSelectStore} disabled={!batchFromState.isBatchEditable}/>
                </FormGroup>
                {batchFromState?.dimensionSelectViewState?.dimensionsEnabled && batchFromState?.dimensionSelectViewState?.dimensionSelectStates?.map(dimensionSelectStore => batchFromState.buildDimensions(dimensionSelectStore))}
              </>
            ) : (<></>)
          }

          {batchType === batchTypesConstatns.CREATE && (
            <>
              <FormGroup>
                <Label>
                  Code Experience:
                </Label>
                <Select
                  id="codeExperience"
                  name="codeExperience"
                  onChange={(data)=>batchFromState.setCodeType(data.value)}
                  options={[
                    { value: 'url', label: 'URL' },
                    { value: 'gs1', label: 'GS1' },
                  ]}
                  defaultValue={{ value: 'url', label: 'URL' }}
                  value = {{ value: batchFromState.selectedCodeType, label: batchFromState.selectedCodeType.toUpperCase() }}
                  isDisabled={!batchFromState.isBatchEditable}
                />
              </FormGroup>
              <FormGroup>
                <Label>
                  Domain:
                </Label>
                <PublishDomainSelectView publishDomainSelectState={batchFromState.publishDomainSelectStore} configs={stateContext?.appConfigs?.configs} disabled={!batchFromState.isBatchEditable} codeState={batchFromState}/>
              </FormGroup>
              <FormGroup>
                <Label>
                  Tags:
                </Label>
                <TagSelect tagSelectStore={batchFromState.tagSelectStore} disabled={!batchFromState.isBatchEditable}/>
              </FormGroup>
            </>
          )}
          {(batchType === batchTypesConstatns.DOWNLOAD || batchType === batchTypesConstatns.EDIT) && (
            <>
              {!batchFromState?.isDefaultBatchOperation && (
                  <>
                    <FormGroup>
                      <Label>
                        Tags:
                      </Label>
                      <Row>
                        <Col sm={10}>
                          <TagSelect tagSelectStore={batchFromState.tagSelectStore} disabled={!batchFromState.isBatchEditable}/>
                        </Col>
                        <Col sm={2}>
                          <CustomInput
                            type="switch"
                            id="isFilterTagTypeOR"
                            name="isFilterTagTypeOR"
                            label={formConstants.Mode.OR}
                            checked={batchFromState.isFilterTagTypeOR}
                            onChange={() => batchFromState.selectFilterTagMethod()}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        Filter:
                      </Label>
                      <InputGroup className="mb-3">
                        {/* <InputGroupAddon addonType="prepend">
                          {intl.formatMessage({id: "listCodes.filter.filterName.defaultMessage"})}
                        </InputGroupAddon> */}
                        <CodeFilterSelect codeFilterSelectState={batchFromState.codeFilterSelectState}/>
                      </InputGroup>
                    </FormGroup>
                  </>)}



             {batchFromState?.isDefaultBatchOperation && (
              <>
                <FormGroup>
                  <Label>
                    Batch Name:
                  </Label>
                  <InputGroup className="mb-3">
                    <BatchSelect batchSelectStore={batchFromState.batchSelectStore} disabled={!batchFromState.isBatchEditable}/>
                  </InputGroup>
                </FormGroup>
              </>)
              }
              {batchType === batchTypesConstatns.DOWNLOAD && (
                <>
                  <FormGroup>
                      <Label>
                        Designer Template:
                      </Label>
                      <InputGroup className="mb-3">
                        <QrConfigSelect store={batchFromState.qrConfigSelectStore} disabled={!batchFromState.isBatchEditable}/>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        Image Format:
                      </Label>
                    <QrDownloadView store={batchFromState} disabled={!batchFromState.isBatchEditable}/>
                  </FormGroup>
                </>
              )}
{/* --------------------------------------------------------------------- Edit Type ------------------------------------------------------------- */}
              {batchType === batchTypesConstatns.EDIT && (
                <>
                  <hr/>
                  <FormGroup>
                    <Label>
                      Edit Type:
                    </Label>
                    <Select id="editType"
                            name="editType"
                            onChange={(data)=>batchFromState.setEditType(data.value)}
                            options={[
                              // { value: batchEditTypes.STATUS, label: batchEditTypes.STATUS },
                              { value: batchEditTypes.TAG, label: batchEditTypes.TAG },
                              { value: batchEditTypes.URL, label: batchEditTypes.URL },
                              // "Others" is the gateway to advanced batch configs (UTM/Parameters/Rules/Status/Designer QR) -
                              // only offer it when the tenant's batch_advanced_configs flag is enabled for this flow.
                              ...(batchFromState.batchAdvancedConfigsEnabled ? [{ value: batchEditTypes.OTHERS, label: batchEditTypes.OTHERS }] : [])
                            ]}
                            defaultValue={{ value: batchEditTypes.TAG, label: batchEditTypes.TAG }}
                            value = {{ value: batchFromState.editType, label: batchFromState.editType }}
                            isDisabled={!batchFromState.isBatchEditable}
                    />

                  </FormGroup>
                  {batchFromState.editType === batchEditTypes.URL && (
                    <FormGroup>
                      <Label>
                        New URL:
                      </Label>
                      <InputGroup className="mb-3">
                        <Input type="text" name="url" value={batchFromState.editValue} onChange={(e)=>batchFromState.setEditValue(e.target.value)} required disabled={!batchFromState.isBatchEditable}/>
                      </InputGroup>
                    </FormGroup>
                  )}
                  {/* {batchFromState.editType === batchEditTypes.STATUS && (
                    <FormGroup>
                      <Label>
                        Change Status To:
                      </Label>
                      <Select id="status"
                              name="status"
                              onChange={(data)=>batchFromState.setEditValue(data.value)}
                              options={[
                                { value: codeStatus.COMPLETED, label: codeStatus.COMPLETED },
                                { value: codeStatus.PAUSED, label: codeStatus.PAUSED },
                                { value: codeStatus.PUBLISHED, label: codeStatus.PUBLISHED }
                              ]}
                              value = {{ value: batchFromState.editValue, label: batchFromState.editValue }}
                              isDisabled={!batchFromState.isBatchEditable}
                      />
                    </FormGroup>
                  )} */}
                  {batchFromState.editType === batchEditTypes.TAG && (
                    <>
                      <FormGroup>
                        <Label>
                          Tag Operation:
                        </Label>
                        <Select id="tagOperation"
                                name="tagOperation"
                                onChange={(data)=>batchFromState.setTagOperation(data.value)}
                                options={[
                                  { value: batchEditTag.ADD_TAG, label: batchEditTag.ADD_TAG },
                                  { value: batchEditTag.REPLACE_TAG, label: batchEditTag.REPLACE_TAG },
                                  { value: batchEditTag.REMOVE_TAG, label: batchEditTag.REMOVE_TAG }
                                ]}
                                defaultValue={{ value: batchEditTag.ADD_TAG, label: batchEditTag.ADD_TAG }}
                                value = {{ value: batchFromState.tagOperation, label: batchFromState.tagOperation }}
                                isDisabled={!batchFromState.isBatchEditable}
                                />
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          Tag:
                        </Label>
                        <Select id="newSelectedTags"
                                name="newSelectedTags"
                                onChange={updatedSelectedTagsOptions => {
                                  const updatedSelectedTags = updatedSelectedTagsOptions ? updatedSelectedTagsOptions.map(option => option.value) : [];
                                  batchFromState.setUpdatedSelectedTags(updatedSelectedTags);
                                }}
                                options={availableSelectedTagOptions}
                                value={batchFromState.updatedSelectedTags.map(tag => ({
                                  value: tag.uuid,
                                  label: tag.name
                                }))}
                                isMulti
                                isDisabled={!batchFromState.isBatchEditable}
                                />
                      </FormGroup>
                    </>
                  )}
                </>
              )}
              {batchFromState.isBatchEditable && !batchFromState?.isDefaultBatchOperation && (
                  <>
                    <FormGroup>
                      <Label>
                        Total Codes:
                      </Label>
                      {batchFromState.downloadCounts}
                    </FormGroup>
                  </>
                )
              }
            </>
          )}
          {(batchFromState.editType === batchEditTypes.OTHERS || batchType === batchTypesConstatns.CREATE) && (
            <>
              {batchFromState.batchAdvancedConfigsEnabled && (
                <>
                  <hr/>
                  <FormGroup>
                    {batchFromState.title === "New Batch" && batchFromState.editType === batchEditTypes.OTHERS && batchType === batchTypesConstatns.EDIT && (
                      <>
                        <Label>
                          <FormattedMessage id="editQr.batchSelectedAdvancedConfigs.defaultMessage"/>
                        </Label>

                          <Select id="selectedAdvancedConfigs"
                              name="selectedAdvancedConfigs"
                              defaultValue={[]}

                              options={[
                                { value: batchEditAdvancedConfigs.UTM, label: batchEditAdvancedConfigs.UTM },
                                { value: batchEditAdvancedConfigs.PARAMETERS, label: batchEditAdvancedConfigs.PARAMETERS },
                                { value: batchEditAdvancedConfigs.RULES, label: batchEditAdvancedConfigs.RULES },
                                { value: batchEditAdvancedConfigs.STATUS, label: batchEditAdvancedConfigs.STATUS },
                                { value: batchEditAdvancedConfigs.DESIGNER_QR, label: batchEditAdvancedConfigs.DESIGNER_QR },
                                // { value: batchEditAdvancedConfigs.EXTENDED_DATA, label: batchEditAdvancedConfigs.EXTENDED_DATA }
                              ]}
                              onChange={(data)=>batchFromState.setSelectedAdvancedConfigs(data, qrPreviewStore)}
                              isMulti
                              isDisabled={!batchFromState.isBatchEditable}
                              menuPlacement="auto"
                              menuPosition="fixed"
                              />

                      </>
                    )}
                    {(batchType === batchTypesConstatns.CREATE || batchFromState.title !== "New Batch") && (
                        <Label>

                          <FormattedMessage id="createQr.advancedConfigs.defaultMessage"/>:
                        </Label>
                    )}
                    <Row className="p-1">
                        <Col sm={10}>
                          {(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.UTM) || batchType === batchTypesConstatns.CREATE)&& (
                            <Button id="utm-config-btn"
                                outline={!(batchFromState.utm.doesUtmHaveValue() || batchFromState.utmModalState.isRemovedUTM)}
                                size="sm"
                                className="btn-outline-secondary mr-1 mb-1"
                                onClick={()=>{batchFromState.handleConfigModalPopUp(UtmModal, "UTM", "utmModalState", "xl");}}>
                                <FormattedMessage id="editQr.advancedConfigsOptions.utm.defaultMessage"/>
                            </Button>)}
                          {(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.PARAMETERS) || batchType === batchTypesConstatns.CREATE)&& (
                            <Button
                                outline={!(batchFromState.parametersHaveValue() || batchFromState.parameterSetModalState.isRemovedParameterSet)}
                                size="sm"
                                className="btn-outline-secondary mr-1 mb-1"
                                onClick={() => {
                                  batchFromState.handleConfigModalPopUp(ParameterSetModal, "Parameters", "parameterSetModalState", "xl","parameters-modal")
                                }}
                              >Parameters
                            </Button>)}
                          {(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.RULES) || batchType === batchTypesConstatns.CREATE) && (
                            <Button
                                outline={!(JSON.parse(batchFromState.rules).length || batchFromState.ruleSetModalState.isRemovedRules)}
                                size="sm"
                                className="btn-outline-secondary mr-1 mb-1"
                                onClick={() => {
                                  if (JSON.parse(batchFromState.rules)[0]?.action) {
                                    batchFromState.ruleSetModalState.setCustomOpen()
                                    batchFromState.ruleSetModalState.createRuleSetState.hydrateTree(JSON.parse(batchFromState.rules))
                                  }
                                  batchFromState.handleConfigModalPopUp(RuleSetModalView, "Rule Set", "ruleSetModalState", "xl","ruleSet-modal")
                                }} >
                              <FormattedMessage id="editQr.advancedConfigsOptions.rules.defaultMessage"/>
                            </Button>)}
                          {(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.STATUS) || batchType === batchTypesConstatns.CREATE) && (
                            <Button id="status-config-btn"
                                // color={createCodeViewState.configButtonColor(createCodeViewState.isStatusNotDefault())}
                                outline={!(batchFromState.statusViewState.isStatusNotDefault() || batchFromState.statusViewState.isChangedStatus)}
                                // className={createCodeViewState?.configClassName(createCodeViewState.isStatusNotDefault())}
                                className="btn-outline-secondary mr-1 mb-1"
                                size="sm"
                                onClick={() => {
                                  batchFromState.handleConfigModalPopUp(StatusView, "Status", "statusViewState", "xl")
                                }}>
                              <FormattedMessage id="editQr.advancedConfigsOptions.status.defaultMessage"/>
                            </Button>)}
                          {(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.DESIGNER_QR) || batchType === batchTypesConstatns.CREATE) && (
                            <Button
                              outline={!(batchFromState.imageUuid || batchFromState.designerModalState.isRemovedDesignerModal)}
                              className="btn-outline-secondary mr-1 mb-1"
                              size="sm"
                              onClick={() => {
                                if(!requiredRolesCheck(ADVANCED_SETTINGS_MANAGE_SET,userRoles)) return
                                batchFromState.handleConfigModalPopUp(DesignerModal, "Designer QR", "designerModalState","xl","designer-modal", qrPreviewStore)
                              }} >
                              Designer QR
                            </Button>)}
                          {/*{(batchFromState.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.EXTENDED_DATA) || batchType === batchTypesConstatns.CREATE) && (
                            <Button
                              outline={!(batchFromState.hasExtendedData() || batchFromState?.extendedDataSettingModalState?.isRemovedExtendedData)}
                              size="sm"
                              className="btn-outline-secondary mr-1 mb-1"
                              onClick={() => {
                                batchFromState.handleConfigModalPopUp(ExtendedDataSettingModal, "Extended Data", "extendedDataSettingModalState","xl");
                              }}>
                              Extended Data
                            </Button>)}
                          */}
                        </Col>
                    </Row>
                  </FormGroup>
                </>
              )}
            </>
          )}
          {batchFromState.isBatchEditable && !batchFromState.showTagDownloadBox && (
            <>
              <hr/>
              <div className="d-flex justify-content-between align-items-center">
                <Nav tabs>
                  <NavItem>
                    <NavLink className={batchFromState.activeTab === 'files' ? 'active' : ''}
                            onClick={() => batchFromState.setActiveTab('files')}>
                      Select CSV File :
                    </NavLink>
                  </NavItem>
                </Nav>
                <div>
                  {(batchFromState?.selectedCodeType === selectedBatchCreateCodetype.GS1) && (
                    <>
                      <a href="https://cdn.scanbuy.com/apps/cmp-v2/files/batch_create_gs1_example_file.csv" download>Download Template</a>
                    </>
                  )}
                  {(batchFromState?.selectedCodeType === selectedBatchCreateCodetype.URL) && (
                    <>
                      <a href="https://cdn.scanbuy.com/apps/cmp-v2/files/batch_create_url_example_file.csv" download>Download Template</a>
                    </>
                  )}

                </div>
              </div>
            </>
          )}
          {!batchFromState.isBatchEditable && batchFromState.batchType === batchTypesConstatns.CREATE && (
            <a href="#" onClick={() => batchFromState.downloadBatchCreateCSV()}>Download Original CSV</a>
          )}
          <TabContent activeTab={batchFromState.activeTab}>
            {batchFromState.isBatchEditable && !batchFromState.showTagDownloadBox && (
            <TabPane tabId="files">
              <FormGroup>
                <StyledDropzone id="dropzone" name="dropzone" setUploadFiles={uploadFiles} />
              </FormGroup>
            </TabPane>)}

          </TabContent>
          {batchFromState.isBatchEditable && (
            <FormGroup>
              <Button color="danger" onClick={handleCancel}>Cancel</Button>
              <Button color="primary" className="float-right" onClick={batchFromState.buttonText === 'edit' ? batchFromState.handleConfigModalPopUp() : handleSubmit}>{batchFromState.buttonText}</Button>
            </FormGroup>
          )}
        </Form>
      </CardBody>
      {/* <CardFooter> <FormattedMessage id="batchForm.alertInfo.defaultMessage"/></CardFooter> */}
      {batchFromState.formHasErrors && <div className="alert alert batch-form-error-alert" role="alert">
          <div>{batchFromState.errorMessage}</div>
        </div>}

    </Card>
    <GenericModal
    modalStore={batchFromState.modalStore}
    componentStore={batchFromState.modalComponentStore}
    EmbedComponent={batchFromState.modalComponent}
    size={batchFromState.modalSize}
    className={batchFromState.modalClassName}
    currentState={batchFromState}
    />
    </>
  );
});


export default BatchForm;
